// =============================================================================
// Suggestions contextuelles de l'assistant par page (clés i18n ui.assistant.sugg.*)
// =============================================================================
// La première règle dont le prefix matche la route courante gagne.
// =============================================================================

export interface SuggestionRule {
  /** Préfixe de route (startsWith). */
  prefix: string;
  /** Clés i18n (sous ui.assistant.sugg) des suggestions à afficher. */
  keys: string[];
}

const RULES: SuggestionRule[] = [
  // --- Espace salarié ----------------------------------------------------------
  {
    prefix: "/app/parcours",
    keys: ["explain_results", "fill_projet", "best_departure", "rachat_worth"],
  },
  { prefix: "/app/historique", keys: ["compare_runs", "explain_results", "best_departure"] },
  { prefix: "/app/documents", keys: ["missing_docs", "explain_ris"] },
  { prefix: "/app/messages", keys: ["draft_message", "where_dossier"] },
  { prefix: "/app/bibliotheque", keys: ["explain_notion", "best_departure"] },

  // --- Espace DRH ---------------------------------------------------------------
  {
    prefix: "/app/drh/reporting",
    keys: ["export_formation_xlsx", "participation_summary", "top_risques"],
  },
  {
    prefix: "/app/drh/salaries",
    keys: ["salaries_inactifs", "export_salaries", "relance_targets"],
  },
  { prefix: "/app/drh/formations", keys: ["export_formation_xlsx", "sessions_remplissage"] },
  { prefix: "/app/drh/relances", keys: ["relance_targets", "salaries_inactifs"] },
  { prefix: "/app/drh", keys: ["participation_summary", "export_salaries", "relance_targets"] },

  // --- Espace Aon (production) ----------------------------------------------------
  { prefix: "/app/aon/dossiers/fiche", keys: ["resume_salarie", "relance_targets"] },
  { prefix: "/app/aon/dossiers", keys: ["resume_dossier", "generate_bri", "next_action"] },
  { prefix: "/app/aon/revue", keys: ["dispatch_stats", "oldest_pending"] },
  { prefix: "/app/aon/relances", keys: ["relance_targets", "oldest_pending"] },
  { prefix: "/app/aon", keys: ["my_workload", "oldest_pending", "dispatch_stats"] },

  // --- Espace admin ---------------------------------------------------------------
  { prefix: "/app/admin/couts-ia", keys: ["ai_costs_month", "ai_top_users"] },
  { prefix: "/app/admin", keys: ["global_stats", "export_salaries", "ai_costs_month"] },

  // --- Défaut ----------------------------------------------------------------------
  { prefix: "/app", keys: ["explain_results", "where_dossier", "explain_notion"] },
];

export function suggestionsForRoute(pathname: string): string[] {
  const rule = RULES.find((r) => pathname.startsWith(r.prefix));
  return rule?.keys ?? [];
}
